// Mobile Menu
document.addEventListener("DOMContentLoaded", () => {
    const mobileMenuButton = document.getElementById("mobile-menu-button");
    const mobileMenu = document.getElementById("mobile-menu");
    const closeButton = document.getElementById("close-mobile-menu");

    if (mobileMenuButton && mobileMenu) {
        mobileMenuButton.addEventListener("click", () => {
            mobileMenu.classList.remove("translate-x-full");
        });
    }

    if (closeButton && mobileMenu) {
        closeButton.addEventListener("click", () => {
            mobileMenu.classList.add("translate-x-full");
        });
    }

    // Desktop Mega Menu

    const menuItems = document.querySelectorAll("#menu-mega-menu-new > li");
    //const menuItems = document.querySelectorAll("#menu-mega-menu > li");
    const container = document.querySelector(".wrappermenu");

    // Add chevron to desktop menu items with children
    menuItems.forEach(item => {
        const child = item.querySelector(".childItem");
        if (child && window.innerWidth >= 1024) {
            const link = item.querySelector("a");
            if (link) {
                const chevron = document.createElement("span");
                chevron.classList.add("menu-chevron");
                chevron.innerHTML = `<svg class="ct-icon" width="8" height="8" viewBox="0 0 15 15" aria-hidden="true"><path d="M2.1,3.2l5.4,5.4l5.4-5.4L15,4.3l-7.5,7.5L0,4.3L2.1,3.2z"></path></svg>`;
                link.appendChild(chevron);
            }
        }
    });
  
    if (!container) return;
  
    const containerRect = container.getBoundingClientRect();
  
    menuItems.forEach(item => {
        const child = item.querySelector(".childItem");
        const link = item.querySelector("a");
  
        if (child && link) {
            const showDropdown = () => {
                const rect = link.getBoundingClientRect();
                const hasImage = child.querySelector('.inner') !== null;

                // Add or remove noimage class based on inner presence
                if (hasImage) {
                    child.classList.remove('noimage');
                } else {
                    child.classList.add('noimage');
                }

                if (hasImage) {
                    const top = rect.bottom - containerRect.top;
                    const left = -rect.left + containerRect.left;
                    
                    child.style.position = "absolute";
                    child.style.left = `${left}px`;
                    child.style.width = `${window.innerWidth}px`;
                    child.style.zIndex = "1000";
                } else {
                    // Reset any previously set styles for no-image submenus
                    child.style.position = "absolute";
                    child.style.left = "";
                    child.style.width = "";
                }
                
                child.style.display = "block";
                child.classList.remove("hidden");
            };
  
            const hideDropdown = () => {
                child.style.display = "none";
                child.classList.add("hidden");
            };
  
            item.addEventListener("mouseenter", showDropdown);
            item.addEventListener("mouseleave", (e) => {
                if (!item.contains(e.relatedTarget)) {
                    hideDropdown();
                }
            });
  
            child.addEventListener("mouseenter", showDropdown);
            child.addEventListener("mouseleave", (e) => {
                if (!item.contains(e.relatedTarget)) {
                    hideDropdown();
                }
            });
        }
    });

    const popup = document.getElementById('popmake-11231');
if (popup) {
    const popupCloseBtn = popup.querySelector('.pum-close');
    if (popupCloseBtn) {
        const handlePopupClose = (e) => {
            e.preventDefault();
            popup.style.display = 'none';
        };

        // Desktop / non-touch
        popupCloseBtn.addEventListener('click', handlePopupClose, false);
        // iOS Safari / touch devices
        popupCloseBtn.addEventListener('touchend', handlePopupClose, false);
    }
}
});

const popupOutside = document.getElementById('popmake-11231');
if (popupOutside) {
    const popupCloseBtnOutside = popupOutside.querySelector('.pum-close');
    if (popupCloseBtnOutside) {
        const handlePopupCloseOutside = (e) => {
            e.preventDefault();
            popupOutside.style.display = 'none';
        };

        // Desktop / non-touch
        popupCloseBtnOutside.addEventListener('click', handlePopupCloseOutside, false);
    }
}

// Global touch handler for iOS Safari / touch devices
document.addEventListener('touchend', (e) => {
    const closeBtn = e.target.closest('.pum-close.popmake-close');
    if (!closeBtn) return;

    const popupContainer = closeBtn.closest('.pum-container');
    const popupOverlay = closeBtn.closest('.pum-overlay');

    if (popupContainer) popupContainer.style.display = 'none';
    if (popupOverlay) popupOverlay.style.display = 'none';
});
